import styled from 'styled-components';
const S = {};

S.SpaceContainer = styled.div`
  display: flex;
  margin-bottom: 0.1rem;
`;

S.StartSeparator = styled.div`
  width: 2.3rem;
  height: 1px;
  background-color: #acabab;
  margin: auto 0;
`;

S.PartName = styled.div`
  padding: 0 0.5rem;
  font-size: 0.9rem;
  font-weight: 700;
  text-align: center;
  color: #000;
`;

S.EndSeparator = styled.div`
  flex-grow: 1;
  height: 1px;
  margin: auto 0;
  background-color: #acabab;
`;

S.MenuTab = styled.div`
  display: flex;
  padding: 0.25rem 2rem;
  background-color: ${({ theme }) => theme.$cmsMenuBackgroundColor};
`;

S.MenuTabIconText = styled.div`
  display: flex;
  flex: 0 1 auto;
  align-items: center;
  margin: 0 1rem;
`;

S.MenuTabIconContainer = styled.div`
  display: flex;
  align-items: center;
  width: 3rem;
  height: 3rem;
  margin: auto;
`;

S.MenuTabIcon = styled.img`
  max-width: 2rem;
  max-height: 2rem;
  vertical-align: middle;
`;

S.MenuTabText = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;
  font-size: 1rem;
  color: ${({ isActive, theme }) => isActive ? theme.$cmsMenuTextColorActive : theme.$cmsMenuTextColor};
`;

export default S;
